module.exports = __webpack_public_path__ + "media/automotive.442b4142.mp4";